export default __webpack_public_path__ + "static/media/perfect_software.fddf5fcb.png";